module.exports = __webpack_public_path__ + "img/level_four.040b206c.png";